const $ = window.jQuery

$(() => {
  $('.slideshow').slick({
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    slide: '.slideshow-slide',
    appendDots: $('.slideshow-controls')
  })
})
